"use client";

import { memo } from "react";

export const RouteTransition = memo(function RouteTransition({ children }: { children: React.ReactNode; }) {
    return <div className="dw-app-route-transition" aria-live="off" data-component="RouteTransition" data-location="src/components/ui/providers/route-transition.tsx">{children}</div>;
});
